export default {"src":"/_next/static/media/warning.1ae32bd6.svg","height":16,"width":16};